import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import AppointmentConfirmationInstructions from './AppointmentConfirmationInstructions.js';

const AppointmentConfirmationInstructionsContainer = (props)=>{
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    return /*#__PURE__*/ React.createElement(AppointmentConfirmationInstructions, swcHelpers.extends({}, props, {
        isPhone: isPhone
    }));
};

export { AppointmentConfirmationInstructionsContainer, AppointmentConfirmationInstructionsContainer as default };
//# sourceMappingURL=AppointmentConfirmationInstructionsContainer.js.map
